import { jsx, Fragment } from 'react/jsx-runtime';
import { useContext, useMemo } from 'react';
import { ModalHistoryContext } from '../History/History.js';

const ModalSwitch = ({ path, children })=>{
    const { history, route } = useContext(ModalHistoryContext);
    // To prevent context to be mounted when any modal open,
    // we check the history routes to match if at least one
    // route start with the switch root path and mount the context.
    // When the current route is not matching the switch path,
    // it won't mount the context and routes inside the switch.
    return useMemo(()=>// Check the current route
        route?.pathname.startsWith(path) === true || // Check history
        history.some((r)=>r.pathname.startsWith(path)) ? jsx(Fragment, {
            children: children
        }) : null, [
        route?.pathname,
        path,
        history,
        children
    ]);
};

export { ModalSwitch };
//# sourceMappingURL=Switch.js.map
